module.exports = "https://cdn.dove.it/_next/static/public/assets/press/logo-ansa.3740c5a7f7af80fcd8b3509a6882c7f6.png";